var _circle, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPetra = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    clipRule: "evenodd",
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    viewBox: "0 0 1000 1000",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 500,
    cy: 500,
    fill: "#ff5f5f",
    r: 500
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m477.988 863.4c-132.942 0-240.714-107.771-240.714-240.714v-398.55l240.714-87.536z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m522.012 564.402c132.942 0 240.714-107.772 240.714-240.714v-99.552l-240.714-87.536z"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPetra);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/petra.6301ef951afea20efb9696ccfe2fa732.svg";